export const reportInterval = 500 // ms
export const microphoneInterval = 250 // ms
export const clearStaleResultsAfter = 3 * 60 * 1000 // ms
export const bufferSize = 4096 // b
export const sampleRate = 16000 // Hz
export const modelPath = `${process.env.PUBLIC_URL}/models/silero_vad.onnx`
